/* eslint-disable */
import React from 'react';
import {
  Box,
  Heading,
  Stack,
  Text,
  Flex,
  Badge,
} from '@chakra-ui/react';

function SummaryItem({ label, value }) {
  const display = value === undefined || value === null || value === '' ? '—' : String(value);
  return (
    <Flex
      direction={{ base: 'column', md: 'row' }}
      justify="space-between"
      align={{ base: 'flex-start', md: 'flex-start' }}
      gap={{ base: 1, md: 4 }}
      borderBottom="1px"
      borderColor="gray.200"
      pb="12px"
      mb="12px"
      w="100%"
      minW={0}
    >
      <Text color="gray.600" fontWeight="600" flexShrink={0}>
        {label}
        :
      </Text>
      <Text
        flex="1"
        minW={0}
        textAlign={{ base: 'left', md: 'right' }}
        wordBreak="break-word"
        overflowWrap="anywhere"
      >
        {display}
      </Text>
    </Flex>
  );
}

function Step5Review({ form, showVet = true }) {
  return (
    <Box maxW="100%" overflow="hidden">
      <Heading size="md" mb="4">Appointment Summary</Heading>
      <Box bg="gray.50" p={{ base: 4, md: 5 }} borderRadius="8px">
        <Stack spacing="12px">
          <SummaryItem label="Location" value={form.location?.name} />
          {showVet && (
            <SummaryItem
              label="Vet"
              value={form.assignedVet?.name || form.provider?.name}
            />
          )}
          <SummaryItem
            label="Date"
            value={form.date ? new Date(form.date).toLocaleDateString('en-US', {
              weekday: 'long', year: 'numeric', month: 'long', day: 'numeric',
            }) : ''}
          />
          <SummaryItem label="Time" value={form.time} />
          <SummaryItem label="Returning Client" value={form.returningClient || 'Not specified'} />
          <SummaryItem label="Number of Pets" value={form.numberOfPets || 'Not specified'} />
          {form.pets?.map((pet, index) => (
            <Box key={index} border="1px" borderColor="gray.200" borderRadius="md" p="3" mb="3" minW={0}>
              <Text fontWeight="600" mb="2">Pet {index + 1}</Text>
              <SummaryItem label="Animal Name" value={pet.animalName || 'Not specified'} />
              <SummaryItem label="Reason for Visit" value={pet.reason || 'Not specified'} />
              <SummaryItem label="Species" value={pet.species || 'Not specified'} />
              {pet.breed && <SummaryItem label="Breed" value={pet.breed} />}
            </Box>
          ))}
          <SummaryItem label="Email" value={form.email || 'Not specified'} />
          <SummaryItem label="Mobile" value={form.mobile || 'Not specified'} />
          <SummaryItem label="First Name" value={form.firstName || 'Not specified'} />
          <SummaryItem label="Last Name" value={form.lastName || 'Not specified'} />
          <SummaryItem label="Address" value={form.address || 'Not specified'} />
          <SummaryItem label="Eircode" value={form.eirCode || 'Not specified'} />
          <Stack direction="row" spacing="8px" align="center" flexWrap="wrap">
            <Badge colorScheme={form.marketingOptIn ? 'green' : 'gray'}>Marketing</Badge>
          </Stack>
        </Stack>
      </Box>
    </Box>
  );
}

export default Step5Review;